const autoNgTemplateLoaderTemplate1 = require('./ldap-group-search-item.html');

import controller from './ldap-group-search-item.controller';

export const ldapGroupSearchItem = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    config: '=',
    index: '<',
    domainSuffix: '@',
    baseFilter: '@',

    onRemoveClick: '<',
    limitedFeatureId: '<',
  },
};
